import React, { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { FullPageSpinner } from '@/components/ui/fullPageSpinner/FullPageSpinner.comp.tsx';
import { captureAppException } from '@/monitoring/sentry.util.ts';
import {
  canReloadAfterChunkLoadError,
  isChunkLoadError,
  reloadAfterChunkLoadError,
  reloadApp,
} from '@/utils/appReload.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { GeneralError } from '@/views/generalError/GeneralError.view.tsx';

export const RouteError: React.FC = () => {
  const error = useRouteError();
  const { t } = useTranslationWithPrefix('generalError');
  const isChunkError = isChunkLoadError(error);

  useEffect(() => {
    if (isChunkError && reloadAfterChunkLoadError()) {
      return;
    }
    captureAppException(error, { contextName: 'route-error' });
  }, [error, isChunkError]);

  if (isChunkError && canReloadAfterChunkLoadError()) {
    return <FullPageSpinner caption={t('loadingNewVersion')} />;
  }

  return (
    <GeneralError
      buttonLabel={t('refresh')}
      message={isChunkError ? t('newVersionLoadFailed.message') : t('general.message')}
      onButtonClick={() => void reloadApp()}
      subMessage={isChunkError ? t('newVersionLoadFailed.subMessage') : t('general.subMessage')}
    />
  );
};
